var _rect, _path, _path2, _path3, _rect2, _rect3, _rect4, _rect5, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScheduleBoard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 5,
    width: 12.5,
    height: 13.5,
    rx: 1.8,
    stroke: "black",
    strokeWidth: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9H15",
    stroke: "black",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3.2V6",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3.2V6",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 11,
    width: 2.1,
    height: 2.1,
    rx: 0.3,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.4,
    y: 11,
    width: 2.1,
    height: 2.1,
    rx: 0.3,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 14.4,
    width: 2.1,
    height: 2.1,
    rx: 0.3,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8.4,
    y: 14.4,
    width: 2.1,
    height: 2.1,
    rx: 0.3,
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 16.4L20.4 12.2L22 13.8L17.8 18L15.6 18.4L16.2 16.4Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3 13.3L20.9 14.9",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleBoard);
export default __webpack_public_path__ + "static/media/schedule-board.9530971c089c7fb38e4586cca02738cd.svg";
export { ForwardRef as ReactComponent };